<template lang="pug">
  .company-list
    n-delete-dialog(
      :value="!!deletingItem"
      :loading="loading"
      @ok="handleDeleteCompany"
      @close="deletingItem = null"
    )
      label
        | Sind Sie sicher, dass Sie den Kunden "{{ deletingItem ? deletingItem.company_name : '' }}" löschen möchten?<br><br>
        | ACHTUNG: Durch das Löschen werden auch sämtliche Beratungen permanent gelöscht!<br><br>
        | Dieser Vorgang ist nicht umkehrbar!

    h2.primary--text Kunden

    v-row.align-center.mt-4
      v-col(cols="6")
        v-text-field.pt-0(
          v-model="search"
          append-icon="search"
          placeholder="Suchen"
          outlined
          single-line
          hide-details
        )

      v-col.text-right(v-if="selectedAgency" cols="6")
        v-btn(color="primary" @click="gotoRoute('company-add')") + Neuen Kunden anlegen

    v-data-table.mt-4(
      v-bind="tableProps"
      :headers="headers"
      :items="companies"
      :search="search"
      :options="defaultPagination"
    )
      template(#item.#="{ item }")
        .action-col.d-flex.align-center.justify-start
          a.mr-1(title="Kunde bearbeiten" @click.prevent="onEditCompany(item)")
            i.fo.fo-large.fo-pencil.primary--text

          a.mr-1(
            title="Kunde löschen"
            @click.prevent="deletingItem = item"
          )
            i.fo.fo-trash-bin.primary--text

          a.mr-1(
            v-if="!selectedCompany || selectedCompany.id !== item.id"
            title="Kunde wählen"
            @click.prevent="onSelectCompany(item)"
          )
            svg-star(color="primary" size=18)

      template(#footer.page-text="{ pageStart, pageStop }")
        span Von {{ pageStart }} bis {{ pageStop }}

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

import FormMixin from '@/mixins/form'
import Urls from '@/router/urls'

@Component({
  mixins: [
    FormMixin
  ],

  components: {
    SvgStar: () => import('@/components/svgs/svg-star')
  }
})
export default class CompanyList extends Vue {
  search = ''
  headers = [
    {
      text: 'ID',
      align: 'left',
      sortable: true,
      value: 'id'
    },
    {
      text: 'Name',
      align: 'left',
      sortable: true,
      value: 'company_name'
    },
    {
      text: 'Standort',
      align: 'left',
      sortable: true,
      value: 'location_name'
    },
    {
      text: 'PLZ',
      align: 'left',
      sortable: false,
      value: 'plz'
    },
    {
      text: 'Ort',
      align: 'left',
      sortable: true,
      value: 'city'
    },
    {
      text: 'Land',
      align: 'left',
      sortable: true,
      value: 'country'
    },
    {
      text: 'Aktion',
      align: 'right',
      width: 120,
      sortable: false,
      value: '#'
    },
  ]

  deletingItem = null
  loading = false

  handleDeleteCompany () {
    if (!this.deletingItem) {
      return
    }

    this.loading = true
    this.$axios
      .delete(Urls.Company(this.deletingItem.id))
      .then(() => {
        this.loadCompanies()
        if (this.selectedCompany && this.selectedCompany.id === this.deletingItem.id) {
          this.selectCompany(null)
        }
        this.deletingItem = null
      })
      .catch(err => {
        this.$toast.error(err.message, 'Fehler')
      })
      .finally(() => {
        this.loading = false
      })
  }

  onEditCompany (item) {
    this.$router.push({
      name: 'company-edit',
      params: {
        id: item.id
      }
    })
  }

  onSelectCompany (item) {
    this.selectCompany({
      id: item.id,
      name: item.company_name
    })
    this.gotoRoute('consultation-list')
  }
}
</script>

<style lang="sass" scoped>
.action-col
  float: right
  max-width: 60px
  width: 60px
</style>
